// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductOverview_container__1XGgz","imageColumn":"ProductOverview_imageColumn__6uEsr"};